import { GAME_ID, WORD_TYPE } from 'a/unmaskThat/data/constants';

const initialState = {
  props: [],
  layouts: [],
  response: '',
  middleWordIndex: -1,
};
const wordsReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    case 'SET_WINDOW_TYPE':
      return { ...initialState };
    case 'SET_WORD_PROPS':
      return {
        ...state,
        props: action.wordProps,
        response: '',
        middleWordIndex: -1,
      };
    case 'UPDATE_WORD_PROPS': {
      const props = state.props.map((word, index) => {
        if (index === action.index) {
          return {
            ...word,
            ...action.wordProps,
          };
        }
        return word;
      });
      return {
        ...state,
        response: getResponse(props),
        middleWordIndex: getMiddleWordIndex(props),
        props,
      };
    }
    case 'SELECT_RANGE': {
      const props = state.props.map((word, index) => {
        if (index >= action.fromIndex && index <= action.toIndex) {
          return {
            ...word,
            type: WORD_TYPE.SELECTED,
          };
        } if (word.type !== WORD_TYPE.ANAPHORA) {
          return {
            ...word,
            type: WORD_TYPE.PLAIN,
          };
        }
        return word;
      });
      return {
        ...state,
        props,
        response: getResponse(props),
        middleWordIndex: getMiddleWordIndex(props),
      };
    }
    case 'RESET_SELECTION':
      return {
        ...state,
        props: state.props.map(word => ({
          ...word,
          type: word.type === WORD_TYPE.SELECTED ? WORD_TYPE.INTERACTABLE : word.type,
        })),
        response: '',
        middleWordIndex: -1,
      };
    case 'UPDATE_WORD_LAYOUT': {
      const layouts = [...state.layouts];
      layouts[action.index] = action.layout;
      return {
        ...state,
        layouts,
      };
    }
    default:
      return state;
  }
};

const getResponse = (words) => {
  const response = [];
  words.forEach(({ type, text }) => {
    if (type === WORD_TYPE.SELECTED) {
      response.push(text);
    }
  });
  return response.join(' ');
};

const getMiddleWordIndex = (words) => {
  const responseIndices = [];
  words.forEach(({ type }, index) => {
    if (type === WORD_TYPE.SELECTED) {
      responseIndices.push(index);
    }
  });
  return responseIndices[Math.floor(responseIndices.length / 2)];
};

export default wordsReducer;
